import { atom } from 'recoil';

const backPressState = atom({
  key: 'backPressStateAtom',
  default: false
})

//Loding Spanner 상태
const loadingState = atom({
  key: 'loadingStateAtom',
  default: {
    isLoading: false,
  },
});

//헤더타이틀
// icon: ['share', 'home', 'menu-lines', 'close', 'exit', 'search', 'bell'],
const headerInfoState = atom({
  key: 'headerInfoAtom',
  default: {
    title: '',
    left: {
      icon: ['back'],
    },
    right: {
      icon: ['home', 'menu-lines'],
    },
    onClick : () => {}
  },
});

//사이드메뉴 Open/Close 여부
const sideMenuState = atom({
  key: 'sideMenuStateAtom',
  default: { isOpen: false },
});

//메뉴
const menuListState = atom({
  key : 'menuListStateAtom',
  default:[],
  effects_UNSTABLE: [
    ({ setSelf, onSet }) => {
      const key = 'menuListState';
      const savedValue = localStorage.getItem(key);

      if (savedValue != null) {
        setSelf(JSON.parse(savedValue));
      }

      onSet((newValue) => {
        localStorage.setItem(key, JSON.stringify(newValue));
      });
    },
  ],
})

const appRefreshState = atom({
  key : 'appRefreshStateAtom',
  default : null
})
export { loadingState, backPressState, headerInfoState, sideMenuState, menuListState, appRefreshState };
